export default "__VITE_ASSET__D8YiwGAK__"